module.exports = __webpack_public_path__ + "static/media/preview.ccf1a2e0.jpg";